import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/ti-home-a.css';
import '../styles/ti-home-b.css';
import { HOME_HTML } from './tripink/homeMarkup';
import { initHome } from './tripink/homeInit';
import { mountShell } from './tripink/shell';
import { addShopLink } from './tripink/navShop';
import { tiAsset } from '../data/tripinkAssets';

/* Images used from CSS (hero glow + bulb-chase layers); set as CSS variables on the page root. */
const CSS_ASSETS = ['v3-hero-glow.jpg', 'v3-hero-glow-phone.jpg', 'v3-hero-bulbs.jpg', 'v3-hero-bulbs-phone.jpg'];
const REVIEWS_SCRIPT = 'https://api.leadconnectorhq.com/js/reviews_widget.js';

/* v5 homepage (approved 2026-10-14): neon "TRIP INK TATTOO" sign hero with the looping sign video on desktop,
   crew, vault, Up for Grabs + Show Me, How Many Days, live 1Dash.Pro reviews, booking, FAQ, extras, footer.
   Rules kept from the prototype: SHOW_RATES=false ("Full-day rate on request"), deposit "to confirm",
   no walk-in wording, reviews iframe + script untouched. Config lives at the top of tripink/homeInit.ts. */
export function Home() {
  const ref = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const navRef = useRef(navigate);
  navRef.current = navigate;
  useEffect(() => {
    const root = ref.current;
    if (!root) return;
    root.innerHTML = HOME_HTML.replace(/assets\/([\w.-]+\.(?:jpg|png|mp4))/g, (_m, n: string) => tiAsset(n));
    addShopLink(root);
    CSS_ASSETS.forEach(n => root.style.setProperty(`--tia-${n.replace(/\W/g, '-')}`, `url("${tiAsset(n)}")`));
    const undoShell = mountShell(root, to => navRef.current(to), {
      title: 'Trip Ink Tattoo Las Vegas | What Happens in Vegas Stays on Your Skin',
      description: "Book a full day with Las Vegas' top tattoo artists. Seven artists at the entrance of Hot Rod City.",
      scrollPadding: '80px',
      background: '#020203'
    });
    const cleanup = initHome(root);

    // Live 1Dash.Pro reviews widget: the iframe is in the markup, the script loads here.
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = REVIEWS_SCRIPT;
    s.async = true;
    root.appendChild(s);
    return () => {
      cleanup();
      undoShell();
      root.innerHTML = '';
    };
  }, []);
  return <div ref={ref} className="ti-home" data-id="element-416" data-mp="1fmfcl2if3zv7" />;
}